<template>
  <div>
    <div class="row innerPage" v-if="lstSolicitacoes.idsolicitacaocondicaopublicacao != null">
      <div class="col-sm-4">
        <span
          ><toggle-button
            @change="editSolicitacoesEspecificas"
            v-model="lstSolicitacoes.flvagareservada"
            :sync="true"
          />
          Vagas reservadas</span
        >
      </div>
      <div class="col-sm-4">
        <span
          ><toggle-button
            @change="editSolicitacoesEspecificas"
            v-model="lstSolicitacoes.fllaudoobrigatorio"
            :sync="true"
          />
          Laudo obrigatório</span
        >
      </div>
    </div>
    <b-tabs
      class="mt-4"
      v-if="lstSolicitacoes.idsolicitacaocondicaopublicacao != null"
      v-model="tdeficiencia"
    >
      <b-tab title="Tipo de Isenção" active>
        <fcc-tipo-deficiencia
          v-if="tdeficiencia == 0"
          :id-publicacao="idPublicacao"
          @salvarMetadados="salvarMetadados"
          :lstSolicitacoes="lstSolicitacoes"
        />
      </b-tab>
      <b-tab title="Necessidade Solicitações Específicas">
        <fcc-solicitacoes-especificas-publicacao
          :id-publicacao="idPublicacao"
          v-if="tdeficiencia == 1"
        />
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'
import FccTipoDeficiencia from './FccTipoDeficiencia.vue'
import FccSolicitacoesEspecificasPublicacao from './FccSolicitacoesEspecificasPublicacao.vue'
export default {
  components: { FccTipoDeficiencia, FccSolicitacoesEspecificasPublicacao },
  data() {
    return {
      spi: '',
      titlePage: 'Cargo(s)',
      add: false,
      tdeficiencia: 0,
      cidade: {
        codcidexame: 0,
        descricao: ''
      },
      baseUrlPublicacao: store.state.baseUrlPublicacao,
      lstSolicitacoes: {},
      fieldsCidades: [
        { key: 'codcidexame', label: 'ID', active: true },
        { key: 'descricao', label: 'Descrição', active: true },
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print', active: true }
      ],

      actions: [
        {
          button: true,
          funcaoButton: 'editCidades',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ]
    }
  },
  methods: {
    addField: function () {
      this.add = true
      this.$root.$emit('bv::show::modal', 'addFieldCidade')
    },
    async salvarMetadados(idPublicacao, zera = false) {
      this.lstSolicitacoes = {}
      const pub = {
        idpublicacao: idPublicacao,
        limpatabela: zera,
        cdfuncionario: this.dadosUserSession.usuCdFuncionario
      }
      this.alimentarSolicitacaoEspecifica(pub).then(() => {
        this.listarSolicitacaoCondicao(idPublicacao)
      })
    },
    editCidades(_, item) {
      this.add = false
      this.cidade = { ...item }
      this.$root.$emit('bv::show::modal', 'addFieldCidade')
    },
    addCidade() {
      const cidade = {
        spi: this.spi,
        codcidexame: this.cidade.codcidexame,
        descricao: this.cidade.descricao,
        fldisponivel: 1
      }
      this.carregaTexto(this.codeMensagem('C01'))
      this.inserirCidadeSPI([cidade])
        .then(() => {
          this.buscarCidades()
          this.callToast(this.mensagensUpdate.adicionado)
        })
        .catch(this.setErrorSystem)
        .finally(() => {
          this.carregaTexto()
          this.$root.$emit('bv::show::modal', 'addFieldCidade')
        })
    },
    editSolicitacoesEspecificas() {
      axios
        .put(
          this.baseUrlLaudoMedico + 'SolicitacaoCondicaoEspecialPublicacao/Alterar',
          this.lstSolicitacoes,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.callToast(this.mensagensUpdate.editado)
          this.listarSolicitacaoCondicaoEspecialPublicacao(this.lstSolicitacoes.idpublicacao)
        })
        .finally(this.carregaTexto)
    },
    listarSolicitacaoCondicao(idPublicacao) {
      this.carregaTexto(this.codeMensagem('C01'))
      this.listarSolicitacaoCondicaoEspecialPublicacao(idPublicacao)
        .then((response) => {
          if (response == null) {
            this.salvarMetadados(idPublicacao)
          } else {
            this.lstSolicitacoes = response
            this.carregaTexto()
          }
        })
        .catch(this.setErrorSystem)
    }
  },
  mounted() {
    this.listarSolicitacaoCondicao(this.idPublicacao)
  },
  props: {
    idPublicacao: Number,
    controlePage: Object
  }
}
</script>